// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    align-items: center;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

.home-top-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 20px 0 10px;
    background-color: transparent;
}

.home-content {
    width: 90%;
    max-width: 400px;
    margin: 0 auto;
    padding: 0;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
}

.party-members-container {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}

.party-members {
    background: rgba(0, 0, 0, 0.7);
    border-radius: 8px;
    padding: 20px;
    margin: 0 0 20px 0;
    width: 100%;
    box-shadow: 0 4px 15px rgba(255, 119, 0, 0.3);
    border: 1px solid rgba(255, 119, 0, 0.2);
    backdrop-filter: blur(5px);
    color: #fff;
    box-sizing: border-box;
}

.party-members h3 {
    color: #ff7700;
    margin-bottom: 15px;
    text-align: center;
    font-size: 1.25rem;
    font-weight: 600;
}

.members-list {
    list-style: none;
    padding: 0;
    margin: 0;
    margin-bottom: 10px;
    font-size: 1rem;
    max-height: 200px;
    overflow-y: auto;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.3);
    padding: 10px;
}

.members-list li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 10px;
    margin-bottom: 5px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
    color: #fff;
    transition: background-color 0.3s ease;
}

.members-list li:hover {
    background: rgba(255, 255, 255, 0.15);
}

.members-list li.current-user {
    background: rgba(255, 119, 0, 0.2);
    border-left: 3px solid #ff7700;
    color: #fff;
}

.error-message {
    color: #ffcccc;
    text-align: center;
    padding: 10px;
    background: rgba(255, 0, 0, 0.2);
    border-radius: 5px;
    margin: 10px 0;
}

.leave-party-btn {
    display: block;
    margin: 20px auto 0;
    padding: 10px 20px;
    background-color: #ff7700;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 1rem;
    font-weight: 600;
}

.leave-party-btn:hover:not(:disabled) {
    background-color: #ff9d4d;
    transform: translateY(-2px);
}

.leave-party-btn:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
    opacity: 0.65;
}

/* Bottom Carousel Styles */
.carousel-section {
    width: 100%;
    max-width: 500px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0;
    padding: 0;
}

.carousel-heading {
    color: #f4511e;
    font-size: 1.25rem;
    margin: 0 0 5px 0;
    text-align: center;
    font-weight: 600;
}

.carousel-container {
    width: 100%;
    position: relative;
    margin: 0;
    padding: 0;
}

.bottom-carousel {
    position: relative;
    width: 100%;
    height: 250px;
    margin: 0;
    overflow: hidden;
}

@media screen and (max-width: 768px) {
    .home-content {
        padding: 0 15px;
    }

    .party-members {
        padding: 15px;
    }

    .carousel-container,
    .bottom-carousel {
        height: 200px;
    }
}

@media screen and (max-width: 480px) {
    .home-content {
        width: 90%;
        max-width: 350px;
    }

    .carousel-section {
        width: 90%;
        max-width: 350px;
    }
}

/* Sidebar Styles */
.sidebar {
    position: fixed;
    top: 0;
    right: -250px;
    width: 250px;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.95);
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
    transition: right 0.3s ease;
    z-index: 1000;
    overflow-y: auto;
}

.sidebar.open {
    right: 0;
}

.sidebar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.sidebar-title {
    color: #f4511e;
    font-size: 1.2rem;
    font-weight: 600;
    margin: 0;
}

.close-sidebar {
    background: none;
    border: none;
    font-size: 1.5rem;
    color: #777;
    cursor: pointer;
    padding: 0;
}

.sidebar-content {
    padding: 15px;
}

.sidebar-menu {
    list-style: none;
    padding: 0;
    margin: 0;
}

.sidebar-menu li {
    margin-bottom: 10px;
}

.sidebar-menu a {
    display: block;
    padding: 10px 15px;
    color: #333;
    text-decoration: none;
    font-weight: 600;
    border-radius: 4px;
    transition: background-color 0.2s;
}

.sidebar-menu a:hover {
    background-color: rgba(244, 81, 30, 0.1);
    color: #f4511e;
}

.sidebar-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: none;
}

.sidebar-overlay.open {
    display: block;
}

.menu-button {
    position: fixed;
    top: 15px;
    right: 15px;
    background-color: #f4511e;
    color: white;
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 998;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    padding: 0;
    transition: background-color 0.3s, transform 0.2s;
}

.menu-button:hover {
    background-color: #e64a19;
    transform: scale(1.05);
}

.menu-button:active {
    transform: scale(0.95);
}

/* About Page Content */
.about-content {
    padding: 20px;
    background-color: rgba(255, 255, 255, 0.95);
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.about-content h2 {
    color: #f4511e;
    margin-top: 0;
    margin-bottom: 15px;
    font-size: 1.25rem;
    font-weight: 600;
}

.about-content p {
    margin-bottom: 15px;
    line-height: 1.5;
}

/* Gallery Content */
.gallery-container {
    width: 100%;
    padding: 20px 10px;
    max-width: 600px;
    margin: 0 auto;
}

.gallery-heading {
    color: #f4511e;
    margin-top: 0;
    margin-bottom: 20px;
    font-size: 1.5rem;
    font-weight: 600;
    text-align: center;
}

.gallery-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    margin-bottom: 20px;
    width: 100%;
}

.gallery-item {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    transition: transform 0.2s ease;
    aspect-ratio: 1;
}

.gallery-item:hover {
    transform: scale(1.03);
}

.gallery-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* Gallery Modal Navigation */
.nav-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.7);
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    cursor: pointer;
    transition: background-color 0.2s;
}

.nav-button:hover {
    background: rgba(255, 255, 255, 0.9);
}

.prev-button {
    left: 15px;
}

.next-button {
    right: 15px;
}

.image-counter {
    position: absolute;
    bottom: 15px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.6);
    color: white;
    padding: 5px 10px;
    border-radius: 15px;
    font-size: 0.9rem;
}

.top-logo {
    cursor: pointer;
    transition: transform 0.2s ease;
}

.top-logo:hover {
    transform: scale(1.05);
}

.spinning-logo {
    animation: spin 6s linear infinite;
    transform-origin: center;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

/* Home challenges section */
.home-challenges-section {
    width: 100%;
    margin-top: 25px;
}

.home-challenges-section .raffle-container,
.home-challenges-section .raffle-user-view {
    max-width: 100%;
    width: 100%;
    margin: 0;
    box-sizing: border-box;
}

.home-content {
    width: 90%;
    max-width: 500px;
    margin: 0 auto;
    padding: 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 1;
    position: relative;
}

/* Adjust spacing when raffle is present */
.home-page .carousel-section {
    margin-top: 25px;
}

@media screen and (max-width: 768px) {
    .home-challenges-section {
        margin-top: 20px;
    }

    .home-challenges-section .raffle-container,
    .home-challenges-section .raffle-user-view {
        padding: 15px;
    }

    .home-content {
        max-width: 450px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,UAAU;IACV,sBAAsB;IACtB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,6CAA6C;IAC7C,wCAAwC;IACxC,0BAA0B;IAC1B,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,oCAAoC;IACpC,kBAAkB;IAClB,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,gCAAgC;IAChC,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;AACjB;;AAEA,2BAA2B;AAC3B;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,gBAAgB;IACpB;AACJ;;AAEA,mBAAmB;AACnB;IACI,eAAe;IACf,MAAM;IACN,aAAa;IACb,YAAY;IACZ,aAAa;IACb,2CAA2C;IAC3C,yCAAyC;IACzC,2BAA2B;IAC3B,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,2CAA2C;AAC/C;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,wCAAwC;IACxC,UAAU;IACV,iDAAiD;AACrD;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,2CAA2C;IAC3C,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;IACxC,eAAe;IACf,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,oCAAoC;IACpC,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,8BAA8B;IAC9B,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;IAClC,wBAAwB;AAC5B;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA,4BAA4B;AAC5B;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,UAAU;IACV,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,kBAAkB;AACtB;;AAEA,0CAA0C;AAC1C;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".home-page {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n    width: 100%;\n    overflow-y: auto;\n    overflow-x: hidden;\n    align-items: center;\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n}\n\n.home-top-section {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    padding: 20px 0 10px;\n    background-color: transparent;\n}\n\n.home-content {\n    width: 90%;\n    max-width: 400px;\n    margin: 0 auto;\n    padding: 0;\n    box-sizing: border-box;\n    display: flex;\n    justify-content: center;\n}\n\n.party-members-container {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    margin-bottom: 20px;\n}\n\n.party-members {\n    background: rgba(0, 0, 0, 0.7);\n    border-radius: 8px;\n    padding: 20px;\n    margin: 0 0 20px 0;\n    width: 100%;\n    box-shadow: 0 4px 15px rgba(255, 119, 0, 0.3);\n    border: 1px solid rgba(255, 119, 0, 0.2);\n    backdrop-filter: blur(5px);\n    color: #fff;\n    box-sizing: border-box;\n}\n\n.party-members h3 {\n    color: #ff7700;\n    margin-bottom: 15px;\n    text-align: center;\n    font-size: 1.25rem;\n    font-weight: 600;\n}\n\n.members-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    margin-bottom: 10px;\n    font-size: 1rem;\n    max-height: 200px;\n    overflow-y: auto;\n    border-radius: 4px;\n    background: rgba(0, 0, 0, 0.3);\n    padding: 10px;\n}\n\n.members-list li {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 8px 10px;\n    margin-bottom: 5px;\n    background: rgba(255, 255, 255, 0.1);\n    border-radius: 4px;\n    color: #fff;\n    transition: background-color 0.3s ease;\n}\n\n.members-list li:hover {\n    background: rgba(255, 255, 255, 0.15);\n}\n\n.members-list li.current-user {\n    background: rgba(255, 119, 0, 0.2);\n    border-left: 3px solid #ff7700;\n    color: #fff;\n}\n\n.error-message {\n    color: #ffcccc;\n    text-align: center;\n    padding: 10px;\n    background: rgba(255, 0, 0, 0.2);\n    border-radius: 5px;\n    margin: 10px 0;\n}\n\n.leave-party-btn {\n    display: block;\n    margin: 20px auto 0;\n    padding: 10px 20px;\n    background-color: #ff7700;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-size: 1rem;\n    font-weight: 600;\n}\n\n.leave-party-btn:hover:not(:disabled) {\n    background-color: #ff9d4d;\n    transform: translateY(-2px);\n}\n\n.leave-party-btn:disabled {\n    background-color: #6c757d;\n    cursor: not-allowed;\n    opacity: 0.65;\n}\n\n/* Bottom Carousel Styles */\n.carousel-section {\n    width: 100%;\n    max-width: 500px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: 0;\n    padding: 0;\n}\n\n.carousel-heading {\n    color: #f4511e;\n    font-size: 1.25rem;\n    margin: 0 0 5px 0;\n    text-align: center;\n    font-weight: 600;\n}\n\n.carousel-container {\n    width: 100%;\n    position: relative;\n    margin: 0;\n    padding: 0;\n}\n\n.bottom-carousel {\n    position: relative;\n    width: 100%;\n    height: 250px;\n    margin: 0;\n    overflow: hidden;\n}\n\n@media screen and (max-width: 768px) {\n    .home-content {\n        padding: 0 15px;\n    }\n\n    .party-members {\n        padding: 15px;\n    }\n\n    .carousel-container,\n    .bottom-carousel {\n        height: 200px;\n    }\n}\n\n@media screen and (max-width: 480px) {\n    .home-content {\n        width: 90%;\n        max-width: 350px;\n    }\n\n    .carousel-section {\n        width: 90%;\n        max-width: 350px;\n    }\n}\n\n/* Sidebar Styles */\n.sidebar {\n    position: fixed;\n    top: 0;\n    right: -250px;\n    width: 250px;\n    height: 100vh;\n    background-color: rgba(255, 255, 255, 0.95);\n    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);\n    transition: right 0.3s ease;\n    z-index: 1000;\n    overflow-y: auto;\n}\n\n.sidebar.open {\n    right: 0;\n}\n\n.sidebar-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.sidebar-title {\n    color: #f4511e;\n    font-size: 1.2rem;\n    font-weight: 600;\n    margin: 0;\n}\n\n.close-sidebar {\n    background: none;\n    border: none;\n    font-size: 1.5rem;\n    color: #777;\n    cursor: pointer;\n    padding: 0;\n}\n\n.sidebar-content {\n    padding: 15px;\n}\n\n.sidebar-menu {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.sidebar-menu li {\n    margin-bottom: 10px;\n}\n\n.sidebar-menu a {\n    display: block;\n    padding: 10px 15px;\n    color: #333;\n    text-decoration: none;\n    font-weight: 600;\n    border-radius: 4px;\n    transition: background-color 0.2s;\n}\n\n.sidebar-menu a:hover {\n    background-color: rgba(244, 81, 30, 0.1);\n    color: #f4511e;\n}\n\n.sidebar-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 999;\n    display: none;\n}\n\n.sidebar-overlay.open {\n    display: block;\n}\n\n.menu-button {\n    position: fixed;\n    top: 15px;\n    right: 15px;\n    background-color: #f4511e;\n    color: white;\n    border: none;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    z-index: 998;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n    padding: 0;\n    transition: background-color 0.3s, transform 0.2s;\n}\n\n.menu-button:hover {\n    background-color: #e64a19;\n    transform: scale(1.05);\n}\n\n.menu-button:active {\n    transform: scale(0.95);\n}\n\n/* About Page Content */\n.about-content {\n    padding: 20px;\n    background-color: rgba(255, 255, 255, 0.95);\n    border-radius: 8px;\n    margin-bottom: 20px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n.about-content h2 {\n    color: #f4511e;\n    margin-top: 0;\n    margin-bottom: 15px;\n    font-size: 1.25rem;\n    font-weight: 600;\n}\n\n.about-content p {\n    margin-bottom: 15px;\n    line-height: 1.5;\n}\n\n/* Gallery Content */\n.gallery-container {\n    width: 100%;\n    padding: 20px 10px;\n    max-width: 600px;\n    margin: 0 auto;\n}\n\n.gallery-heading {\n    color: #f4511e;\n    margin-top: 0;\n    margin-bottom: 20px;\n    font-size: 1.5rem;\n    font-weight: 600;\n    text-align: center;\n}\n\n.gallery-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n    margin-bottom: 20px;\n    width: 100%;\n}\n\n.gallery-item {\n    border-radius: 8px;\n    overflow: hidden;\n    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);\n    cursor: pointer;\n    transition: transform 0.2s ease;\n    aspect-ratio: 1;\n}\n\n.gallery-item:hover {\n    transform: scale(1.03);\n}\n\n.gallery-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n/* Gallery Modal Navigation */\n.nav-button {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    background: rgba(255, 255, 255, 0.7);\n    border: none;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.5rem;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.nav-button:hover {\n    background: rgba(255, 255, 255, 0.9);\n}\n\n.prev-button {\n    left: 15px;\n}\n\n.next-button {\n    right: 15px;\n}\n\n.image-counter {\n    position: absolute;\n    bottom: 15px;\n    left: 50%;\n    transform: translateX(-50%);\n    background: rgba(0, 0, 0, 0.6);\n    color: white;\n    padding: 5px 10px;\n    border-radius: 15px;\n    font-size: 0.9rem;\n}\n\n.top-logo {\n    cursor: pointer;\n    transition: transform 0.2s ease;\n}\n\n.top-logo:hover {\n    transform: scale(1.05);\n}\n\n.spinning-logo {\n    animation: spin 6s linear infinite;\n    transform-origin: center;\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n/* Home challenges section */\n.home-challenges-section {\n    width: 100%;\n    margin-top: 25px;\n}\n\n.home-challenges-section .raffle-container,\n.home-challenges-section .raffle-user-view {\n    max-width: 100%;\n    width: 100%;\n    margin: 0;\n    box-sizing: border-box;\n}\n\n.home-content {\n    width: 90%;\n    max-width: 500px;\n    margin: 0 auto;\n    padding: 0;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    z-index: 1;\n    position: relative;\n}\n\n/* Adjust spacing when raffle is present */\n.home-page .carousel-section {\n    margin-top: 25px;\n}\n\n@media screen and (max-width: 768px) {\n    .home-challenges-section {\n        margin-top: 20px;\n    }\n\n    .home-challenges-section .raffle-container,\n    .home-challenges-section .raffle-user-view {\n        padding: 15px;\n    }\n\n    .home-content {\n        max-width: 450px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
